import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './DetailForm.scss';

import InputMaterial from '../../UI/InputMaterial/InputMaterial';
import SearchSelectMenu from '../../UI/SearchSelectMenu/SearchSelectMenu';

import mobileMapping from '../../../assets/json/mobileMapping';
import { setUserDetails } from '../../../store/actions/farePrice';

class DetailForm extends Component {

    state = {
        selectedOption: {
            value : "91",
            label : "+ 91"
        }
    }

    componentDidMount() {
        this.props.onSetUserDetails('91', 'mobileISD');
        this.props.onSetUserDetails('8800316481', 'mobile');
        this.props.onSetUserDetails('abhishek.jakhar@yatra.com', 'email');
    }

    handleChange = (selectedOption) => {
        const optionSelected = {...selectedOption};
        optionSelected.label = "+ " + optionSelected.value;
        this.setState({ selectedOption: optionSelected });
    }

    mobileValue = "";

    inputChangeHandler = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.value;
        
        if(name === "email") {
            this.props.onSetUserDetails(value, name);
        } else if (event.target.value === "" && name === "mobile") {
            this.props.onSetUserDetails(value, name);
        } else if (event.target.value.match(/^\d+$/) && name === "mobile") {
            this.props.onSetUserDetails(value, name);
        }
    }

    render() {
        return (
            <div className={`u-flex align-items-center f-wrap f-fill`}>
                    <div className={`u-flex align-items-center u-relative mr-3 u-height60`} style={{flex: '0 0 6.5rem'}}>
                        <SearchSelectMenu 
                            value={this.state.selectedOption}
                            options={mobileMapping} 
                            onChange={this.handleChange} 
                            placeholder='ISD Code' />
                    </div>
                    <div className={`${classes.Number} u-flex align-items-center u-height60`}>
                        <InputMaterial 
                            type='number'
                            label='Mobile Number' 
                            alignment='left' 
                            maxLength="10" 
                            value={this.props.mobile} 
                            onChange={this.inputChangeHandler} 
                            name='mobile'/>
                    </div>
                    <div className={`${classes.Email} u-flex align-items-center u-height60`}>
                        <InputMaterial 
                            type='email' 
                            label='Email ID' 
                            alignment='left' 
                            value={this.props.email} 
                            onChange={this.inputChangeHandler} 
                            name='email'/>
                    </div>
                </div>                
        );
    }
}

const mapStateToProps = state => {
    return {
        mobile: state.farePrice.userParams.additionalContact.mobile,
        mobileISD: state.farePrice.userParams.additionalContact.mobileISD,
        email: state.farePrice.userParams.additionalContact.email,
        // userEmail: state.auth.userProfile.userDetail.email,
        // userMobile: state.auth.userProfile.userDetail.mobileNo,
        // userMobileISD: state.auth.userProfile.userDetail.mc
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSetUserDetails: (val, type) => dispatch(setUserDetails(val, type))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DetailForm);


// WEBPACK FOOTER //
// ./src/components/Addons/DetailForm/DetailForm.js